import { makeCRUDSlice } from '@redux/crudCreator';
import { MODEL_NAME, orderBatchesPickingActions } from './actions';

const slice = makeCRUDSlice(MODEL_NAME, orderBatchesPickingActions);

export default slice.reducer;
